import React from "react";

import { SignIn } from "features/Auth/SignIn";

const SignInPage = () => <SignIn />;

export default SignInPage;
